import defineAbilityFor from '~/utils/ability';
import { api } from '~/utils/api';
import { useViewerBootstrap } from '~/contexts/ViewerBootstrapContext';

export default function useAbility() {
  const bootstrappedAuthorized = useViewerBootstrap();
  const authorizeQuery = api.user.authorize.useQuery(undefined, {
    enabled: !bootstrappedAuthorized,
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
  const authorized = bootstrappedAuthorized ?? authorizeQuery.data;

  const ability = authorized
    ? defineAbilityFor(
        authorized.user.UserWorkspaces[0]?.Role?.isAdmin,
        authorized.user.UserWorkspaces[0]?.Role?.permissions,
      )
    : null;
  return ability;
}
